import { FC } from 'react';
import ScanHistoryContainer from '../../../scan-history/containers/ScanHistoryContainer';
import FixedPage from '../FixedPage';

const ScanHistoryPage: FC<
  React.PropsWithChildren<ScanHistoryPageProps>
> = props => {
  return (
    <FixedPage>
      <ScanHistoryContainer />
    </FixedPage>
  );
};

export interface ScanHistoryPageProps {}

export default ScanHistoryPage;
